import localization from "assets/localization/localization";

export const REPORT_STATUS = {
  COMPLETE: "complete",
  INCOMPLETE: "incomplete",
};

export const FINAL_BILLING_STAGE_ID = "13";

export const hasValidReportUrl = (url) => {
  if (url == null) return false;
  const value = String(url).trim();
  return value !== "" && value !== "#";
};

export const getReportStatus = (siteData) =>
  String(siteData?.report_status || "").toLowerCase();

export const isFinalBillingStage = (siteData, stageId) => {
  const id = siteData?.stage_id ?? stageId;
  return String(id) === FINAL_BILLING_STAGE_ID;
};

export const isReportComplete = (siteData, stageId) => {
  if (!siteData) return false;

  const status = getReportStatus(siteData);
  const resolvedStageId = stageId ?? siteData.stage_id;

  if (isFinalBillingStage(siteData, resolvedStageId)) {
    return status === REPORT_STATUS.COMPLETE;
  }

  return (
    status === REPORT_STATUS.COMPLETE && hasValidReportUrl(siteData.report_url)
  );
};

export const shouldShowReportAttachment = (siteData, stageId) => {
  if (!siteData || isFinalBillingStage(siteData, stageId)) return false;
  return isReportComplete(siteData, stageId);
};

export const shouldShowReportPending = (
  siteData,
  stageId,
  reportGenerationSubmitted = false
) => {
  if (!reportGenerationSubmitted || !siteData) return false;
  if (isFinalBillingStage(siteData, stageId)) return false;
  return !isReportComplete(siteData, stageId);
};

export const canShowGenerateReport = (
  siteData,
  stageId,
  reportGenerationSubmitted = false
) => {
  if (!siteData) return false;

  if (isFinalBillingStage(siteData, stageId)) {
    return (
      getReportStatus(siteData) === REPORT_STATUS.INCOMPLETE &&
      !reportGenerationSubmitted
    );
  }

  if (isReportComplete(siteData, stageId) || hasValidReportUrl(siteData.report_url)) {
    return false;
  }
  if (reportGenerationSubmitted) return false;
  if (getReportStatus(siteData) === REPORT_STATUS.COMPLETE) return false;

  return true;
};

export const getReportPendingMessage = () => localization.reportGenerating;
